import React from 'react'
import styled, { css } from 'styled-components'

const width = '62'
const height = '150'
const viewBox = '0 0 62 150'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g id="surface1" key="surface1">
      <path d="M 34.746094 123.101562 C 20.480469 108.855469 8.457031 96.78125 8.015625 96.273438 C 3.5625 91.046875 0.933594 84.972656 0.144531 78.019531 C -0.0273438 76.484375 -0.0507812 72.914062 0.101562 71.402344 C 0.832031 64.199219 3.738281 57.503906 8.355469 52.394531 C 9.300781 51.351562 60.65625 0 60.757812 0 C 60.902344 0 62 1.128906 62 1.273438 C 62 1.339844 50.378906 13.007812 36.171875 27.195312 C 21.96875 41.382812 10.074219 53.296875 9.75 53.667969 C 5.472656 58.53125 2.875 64.292969 2.015625 70.785156 C 1.808594 72.371094 1.757812 75.601562 1.929688 77.300781 C 2.53125 83.585938 4.820312 89.253906 8.746094 94.1875 C 9.683594 95.363281 9.84375 95.527344 50.652344 136.339844 C 56.875 142.550781 61.972656 147.703125 61.984375 147.777344 C 62.023438 147.949219 61.003906 149 60.808594 149 C 60.742188 149 49.007812 137.339844 34.746094 123.101562 Z M 34.746094 123.101562 " />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconStrokeArrow'
})
